import { posFoodLogo } from 'constants/ui/svg';
import { getToken } from 'helpers';
import { useAppDispatch, useAppSelector } from 'hooks';
import { useEffect, useState, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { MdLogout } from 'react-icons/md';
import { authActions } from 'slices/authSlice';
import { shopListAction } from 'slices/shopSlice';
import { rankingAction } from 'slices/rankingSlice';

import { shopSettingActions } from 'slices/shopSettingSlice';
import { FaChevronDown } from 'react-icons/fa';
import useModal from 'hooks/useModal';
import { Modal } from './components';
import { SelectedShop } from 'models';
import { useNavigate } from 'react-router-dom';
import * as socket from '../../sockets';
import logoRank from '../../assets/images/logo.png';
import { Button, Select } from 'antd';
import * as cts from '../../constants/ui/svg';
import { Link } from 'react-router-dom';

export const SelectedShopPage = () => {
  const isChrome =
    typeof window !== 'undefined' &&
    'chrome' in window &&
    (!!(window.chrome as any)?.webstore || !!(window.chrome as any)?.runtime);
  const userAgent = window.navigator.userAgent;
  const isAndroid = /Android/.test(userAgent);
  const isIOS = /iPhone|iPad|iPod/.test(userAgent);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const token = getToken() as string;

  const shopList = useAppSelector((state) => state.shopList.listShop);
  const selectShop = useAppSelector((state) => state.shopList.selectShop);
  const masterInfo = useAppSelector((state) => state.auth.masterInfo);
  const [selectedShop, setSelectedShop] = useState<SelectedShop | null>(shopList[0]);
  const savedShop = typeof window !== 'undefined' ? localStorage.getItem('selectedShop') : null;

  const [openSelect, setOpenSelect] = useState(false);

  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const listShop = useMemo(() => {
    return [...(shopList || [])].sort((a: any, b: any) => {
      const fa = a.name.toLowerCase();
      const fb = b.name.toLowerCase();
      return fa.localeCompare(fb);
    });
  }, [shopList]);
  const onChangeShop = () => {
    if (selectShop.id !== selectedShop?.id) {
      localStorage.removeItem('selectProgram');
      localStorage.removeItem('dataDateRank');
      localStorage.removeItem('dataDateRankNearest');
      localStorage.removeItem('dataMonthRank');
      localStorage.removeItem('dataDateRankGroupShop');
      localStorage.removeItem('dataMonthRankGroupShop');
    }
  };

  const onEnterMasterMode = () => {
    if (selectShop?.id) {
      localStorage.removeItem('selectProgram');
      localStorage.removeItem('dataDateRank');
      localStorage.removeItem('dataDateRankNearest');
      localStorage.removeItem('dataMonthRank');
      localStorage.removeItem('dataDateRankGroupShop');
      localStorage.removeItem('dataMonthRankGroupShop');
      localStorage.removeItem('selectedShop');
    }
    dispatch(shopListAction.setSelectShop({}));
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setOpenSelect(false); // khi click ngoài thì đóng
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  useEffect(() => {
    if (token) {
      dispatch(shopListAction.fetchShopList({ token }));
    }
  }, [dispatch, token]);
  useEffect(() => {
    if (savedShop && Object.keys(savedShop).length > 0) {
      setSelectedShop(JSON.parse(savedShop));
    } else if (listShop.length > 0) {
      setSelectedShop(listShop[0]);
    }
  }, [listShop.length, savedShop]);
  return (
    <div className={`relative ${isIOS && !isChrome ? 'h-[110vh]' : 'h-[100vh]'}`}>
      {/* Nút logout */}
      <div className="flex absolute z-10 justify-end items-center w-full">
        <Button
          className="flex items-center gap-2 mt-[40px] mr-[40px] border-[#F04438] border border-solid rounded-[6px] w-fit h-[40px] px-[16px]"
          onClick={() => {
            localStorage.removeItem('ID_SELECTED_SHOP');
            localStorage.removeItem('SELECTED_SHOP_ID');
            localStorage.removeItem('selectedShop');
            localStorage.removeItem('POS_CUSTOMER_PAYMENT_SELECTED_SHOP');
            localStorage.removeItem('selectProgram');
            localStorage.removeItem('rankingDate');
            localStorage.removeItem('dataDateRankNearest');
            localStorage.removeItem('dataDateRankGroupShop');
            localStorage.removeItem('dataMonthRankGroupShop');
            localStorage.removeItem('dataDateRank');
            localStorage.removeItem('dataMonthRank');
            dispatch(authActions.logout({ token, params: { notification_token: '' } }));
          }}
        >
          <span>{cts.logOutIcon}</span>
          <span className="text-[14px] notosans_medium text-[#F04438]">{t('LOGOUT')}</span>
        </Button>
      </div>

      {/* Nội dung chính */}
      <div className="h-full overflow-y-auto pb-[20px] w-full">
        <div className="flex flex-1 flex-col items-center h-full mt-[6%]">
          {/* Logo và chọn shop */}
          <div className="flex relative flex-col justify-center items-center lg:mt-0 mt-[20%]">
            <img className="" src={logoRank} />
            {masterInfo.active && (
              <p className="mt-3 text-2xl text-primary font-notosans-700">
                {t('ADMINISTRATOR_MODE')}
              </p>
            )}
            <span className="text-[18px] notosans_normal text-[#1D2939] mt-[30px]">
              {t('SELECT_SHOP_TO_CONTINUE')}
            </span>

            {/* Nút chọn shop */}
            <div className="flex gap-1 justify-center items-center mt-4 w-full">
              <Button
                onClick={() => setOpenSelect(true)}
                className="border border-[#D5D7DA] border-solid h-[40px] rounded-[8px] flex items-center justify-between lg:w-[396px] w-[250px] px-4"
              >
                <span className="text-[16px] notosans_normal text-[#252B37]">
                  {selectedShop?.name || selectShop?.name}
                </span>
                <span>{cts.downIcon}</span>
              </Button>

              <button
                onClick={() => {
                  onChangeShop();
                  const idShopSelect = localStorage.getItem('ID_SELECTED_SHOP');
                  const existing = JSON.parse(localStorage.getItem('rankingDate') || '[]');
                  const isExist = existing.some((item: any) => item.shopId === idShopSelect);

                  if (idShopSelect) {
                    dispatch(shopListAction.setSelectShop(idShopSelect));
                    dispatch(
                      shopSettingActions.getShopSetting({
                        token,
                        params: { shop_id: Number(idShopSelect) },
                      })
                    );
                    navigate(`/settings?tab=3`);
                    if (!isExist) {
                      localStorage.removeItem('rankingDate');
                    }
                  } else {
                    dispatch(shopListAction.setSelectShop(listShop[0]?.id));
                    dispatch(
                      shopSettingActions.getShopSetting({
                        token,
                        params: { shop_id: Number(listShop[0]?.id) },
                      })
                    );
                    localStorage.removeItem('rankingDate');

                    navigate(`/settings?tab=3`);
                  }
                }}
                className="w-[100px] rounded-md h-[40px] border border-solid border-text-secondary text-white text-[16px] notosans_medium bg-text-secondary"
              >
                {t('SELECT')}
              </button>
            </div>
            {masterInfo.active && (
              <Link
                to={'/settings?tab=0'}
                onClick={onEnterMasterMode}
                className="flex items-center justify-between py-4 border-y border-solid border-border-gray max-w-[500px] w-full mt-4 font-notosans-400 text-text-primary hover:!text-text-primary"
              >
                <p className="flex gap-1 items-center">
                  {cts.generalSettingIcon} {t('GENERAL_SETTING')}
                </p>
                <span>{cts.arrowDatePickerRight}</span>
              </Link>
            )}
            {/* Dropdown chọn shop (tuyệt đối để tránh đẩy layout) */}
            {openSelect && (
              <div
                className={`flex flex-col absolute z-50 ${
                  masterInfo.active ? 'top-[calc(100%-70px)]' : 'top-full'
                } mt-1`}
              >
                <div className=" w-full flex justify-center pb-[50px]">
                  <div
                    ref={dropdownRef}
                    className="custom-scroll border border-solid border-[#D5D7DA] rounded-[8px] overflow-y-auto overflow-x-hidden max-h-[400px] lg:w-[396px] w-[250px] bg-white shadow-md"
                  >
                    {listShop?.map((x: any, y: any) => (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          onChangeShop();
                          setSelectedShop(x);
                          setOpenSelect(false);
                          dispatch(shopListAction.setSelectShop(x?.id));
                        }}
                        key={y}
                        className={`${
                          selectedShop?.name === x?.name && 'bg-[#F9F5FF]'
                        } h-[40px] border-b border-[#D5D7DA] w-full flex items-center justify-between px-[16px] hover:bg-[#F9F5FF]`}
                      >
                        <span className="text-[16px] notosans_normal text-[#252B37]">
                          {x?.name}
                        </span>
                        {selectedShop?.name === x?.name && <span>{cts.checkIcon}</span>}
                      </button>
                    ))}
                  </div>
                  <div className="w-[100px]"></div>
                </div>
                <div className="h-[50px]"></div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
